module.exports = __webpack_public_path__ + "4a7808a38e0885ce4f0bc7011d89f750.png";